import { makeStyles } from '@material-ui/core/styles'
import { FilterBackground, FilterBorder } from '../../../../../utils/colors'

export const useStyles = makeStyles((theme) => ({
  NewOrderDialogPaper: {
    borderRadius: 0
  },
  NewOrderDialogContent: {
    padding: '0 !important',
    position: 'relative'
  },
  NewOrderDialogClose: {
    position: 'absolute',
    zIndex: 10,
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.primary.dark
  },
  NewOrderDialogHeader: {
    display: 'flex',
    alignItems: 'center',
    background: FilterBackground,
    border: `1px solid ${FilterBorder}`,
    '& .MuiTypography-root': {
      color: theme.palette.primary.light,
      fontWeight: theme.typography.fontWeightBold
    }
  },
  NewOrderOkAction: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  NewOrderDialogFooter: {
    alignItems: 'flex-end',
    padding: theme.spacing(2)
  },
  DeleteOrderBtn: {
    backgroundColor: theme.palette.error.main + '!important',
    '&:hover': {
      backgroundColor: theme.palette.error.dark + '!important'
    }
  },
  DeleteOrderWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    whiteSpace: 'pre-line',
    '& .MuiAlert-root': {
      width: '100%'
    },
    '& p': {
      textAlign: 'center',
      fontSize: theme.typography.pxToRem(18),
      marginTop: theme.spacing(2)
    }
  },
  NewOrderStepsWrapper: {
    whiteSpace: 'pre-line',
    position: 'relative'
  },
  DeleteWarningIcon: {
    textAlign: 'center',
    fontSize: theme.typography.pxToRem(64),
    color: theme.palette.warning.main
  },
  PaymentOrderStepMessage: {
    whiteSpace: 'pre-line',
    fontSize: theme.typography.pxToRem(18),
    lineHeight: 1.7,
    '&.center': {
      textAlign: 'center'
    },
    '& ol': {
      paddingLeft: theme.spacing(2),
      marginTop: theme.spacing(0.75),
      marginBottom: theme.spacing(2.5)
    },
    '& p': {
      marginBottom: theme.spacing(1)
    }
  },
  PaymentFirstStepActionWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),
    '& button': {
      fontSize: theme.typography.pxToRem(22),
      minWidth: '20%'
    }
  },
  PaymentFirstStepAlert: {
    marginTop: theme.spacing(2),
    '& .MuiAlert-message': {
      fontSize: theme.typography.pxToRem(16)
    }, '& .MuiAlert-icon': {
      fontSize: theme.typography.pxToRem(28)
    }
  },
  NewOrderPayButton: {
    minWidth: '20%'
  },
  fabWrapper: {
    display: 'inline-block',
    position: 'sticky',
    zIndex: 50,
    marginTop: theme.spacing(0.5),
    bottom: theme.spacing(3),
    left: theme.spacing(3)
  },
  speedDialWrapper: {
    height: 56
  },
  speedDialTooltip: {
    fontSize: theme.typography.pxToRem(16)
  },
  fab: {
    color: theme.palette.common.white,
    flex: '0 0 auto',
    '&:hover': {
      backgroundColor: theme.palette.primary.hover
    }
  },
  speedDialActionTooltip: {
    whiteSpace: 'nowrap',
    fontSize: theme.typography.pxToRem(18),
    backgroundColor: FilterBackground,
    color: theme.palette.primary.main,
    marginLeft: theme.spacing(0.5) + 'px !important',
    height: '90%',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      whiteSpace: 'normal',
      paddingRight: theme.spacing(1.5),
      paddingLeft: theme.spacing(1.5),
      fontSize: theme.typography.pxToRem(16),
      minWidth: 300,
      lineHeight: 1.2
    }
  },
  actionsWrapper: {
    paddingBottom: theme.spacing(4.5) + 'px !important'
  },
  speedDialActionFab: {
    margin: theme.spacing(0.375),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    transition: 'all 0.3s ease-in-out',
    '&:hover, &:focus': {
      backgroundColor: theme.palette.primary.hover
    }
  }
}))
